import AnnotationInfo from "./AnnotationInfo";
import AnnotationTextureLayer from "./AnnotationTextureLayer";
import AnnotationType from "./enums/AnnotationType";
import PathInfo from "./PathInfo";

class Annotation {
  constructor(
    public name: string,
    public description: string,
    public icon: number | undefined,
    public shape_and_context: number | undefined,
    public type: AnnotationType,
    public annotation_infos?: AnnotationInfo[] | undefined,
    public id_textures?: number[] | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public id_user?: number | undefined,
    public id_3dinstance?: number | undefined,
    public icon_path?: string | undefined,
    public created_on?: string | undefined,
    public parent?: PathInfo | undefined,
    public username?: string | undefined,
    public texture_layers?: AnnotationTextureLayer[] | undefined,
    public ui_selected_images?: string | undefined,
    public ui_selected_sounds?: string | undefined,
    public ui_shape_and_context?: string | undefined
  ) {}

  public static EmptyInstance(): Annotation {
    return new Annotation("", "", -1, -1, AnnotationType._3D);
  }
}

export default Annotation;
